// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const goose = defineModel({
  id: "goose",
  batchId: "future",
  name: "Goose",
  tags: ["creature","goose","low-poly","age-of-mcp","future","water"],
  summary: "A goose — meat, down, eggs and a watchful guard.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.09,
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.005, 0.004, 0.04, 4), color: "#d88a3a", position: [0, 0.02, 0.016] },
      { geometry: new THREE.CylinderGeometry(0.005, 0.004, 0.04, 4), color: "#d88a3a", position: [0, 0.02, -0.016] },
      { geometry: new THREE.IcosahedronGeometry(0.05, 0), color: "#eef0ee", position: [0, 0.075, 0], scale: [1.5, 1, 1.05] },
      { geometry: new THREE.ConeGeometry(0.016, 0.03, 4), color: "#ffffff", position: [-0.06, 0.092, 0], rotation: [0, 0, 1.9] },
      { geometry: new THREE.CylinderGeometry(0.013, 0.016, 0.04, 6), color: "#ffffff", position: [0.05, 0.11, 0], rotation: [0, 0, -0.5] },
      { geometry: new THREE.CylinderGeometry(0.011, 0.013, 0.04, 6), color: "#ffffff", position: [0.066, 0.145, 0], rotation: [0, 0, -0.1] },
      { geometry: new THREE.IcosahedronGeometry(0.016, 0), color: "#ffffff", position: [0.074, 0.172, 0] },
      { geometry: new THREE.ConeGeometry(0.008, 0.022, 5), color: "#e0902c", position: [0.092, 0.17, 0], rotation: [0, 0, -1.5] },
      { geometry: new THREE.IcosahedronGeometry(0.0035, 0), color: "#181410", position: [0.08, 0.178, 0.012] },
      { geometry: new THREE.IcosahedronGeometry(0.0035, 0), color: "#181410", position: [0.08, 0.178, -0.012] },
    ],
  animations: [],
});
